// needs to be after metadata middleware
export default defineNuxtRouteMiddleware((to, from) => {
  if (
    import.meta.server &&
    !useCookie('wa_referrer') &&
    !useCookie('wa_landing_url')
  ) {
    const referrer = useRequestHeader('referer')
    const referrerDate = $moment().format('ddd, DD MMM YYYY HH:mm:ss')
    useCookie('wa_referrer', referrer)
    useCookie('wa_referrer_date', referrerDate)
    useCookie('current_wa_referrer', referrer)
    useCookie('current_wa_referrer_date', referrerDate)
    useCookie('wa_landing_url', route.fullPath)
    useCookie('current_wa_landing_url', route.fullPath)
    if (route.query.utm_medium === 'email') {
      $cookies.set('wa_from_email', 'yes')
    }
  }
})
